<template>
    <a-modal title="修改案例" v-model:open="open" @ok="handleOk" class="full-modal" :width="'65vw'" :body-style="{ maxHeight: '100vh', overflowY: 'auto' }">
        <div class="form-grid">
            <div class="form-item">
                <a><span class="startColor">*</span>案例编号：</a>
                <a-input v-model:value="pushData.caseNo" maxlength="50" placeholder="编号" disabled />
            </div>
            <div class="form-item">
                <a><span class="startColor">*</span>案例名称：</a>
                <a-input v-model:value="pushData.caseName" maxlength="100" placeholder="请输入案例名称" />
            </div>
            <div class="form-item">
                <a>涉及税种：</a>
                <a-select v-model:value="pushData.taxType" mode="multiple" placeholder="请选择涉及税种">
                    <a-select-option v-for="item in taxTypeOptions" :key="item.id" :value="item.name">{{ item.name }}</a-select-option>
                </a-select>
            </div>
            <div class="form-item">
                <a>行业：</a>
                <a-select v-model:value="pushData.industry" mode="multiple" placeholder="请选择行业">
                    <a-select-option v-for="item in industryOptions" :key="item.id" :value="item.name">{{ item.name }}</a-select-option>
                </a-select>
            </div>
            <div class="form-item">
                <a>纳税人群：</a>
                <a-input v-model:value="pushData.taxpayerType" maxlength="100" placeholder="请输人群" />
            </div>
            <div class="form-item">
                <a>涉及金额：</a>
                <a-input-number v-model:value="pushData.involvedAmount" :precision="2" :min="0" placeholder="请输入金额" style="width:100%" addonAfter="万元" />
            </div>
            <div class="form-item">
                <a>问题关键词：</a>
                <a-select v-model:value="pushData.keyword" mode="multiple" placeholder="请选择问题关键词">
                    <a-select-option v-for="item in keywordOptions" :key="item.id" :value="item.keyword">{{ item.keyword }}</a-select-option>
                </a-select>
            </div>
            <div class="form-item">
                <a>案例来源：</a>
                <a-input v-model:value="pushData.caseSource" maxlength="100" placeholder="请输入案例来源" />
            </div>
            <div class="form-item">
            </div>
            <div class="form-item form-colspan-2">
                <a>案例背景：</a>
                <a-textarea v-model:value="pushData.caseBackground" maxlength="2000" :rows="3" placeholder="请输入案例背景" />
            </div>
            <div class="form-item">
                <a>核心问题：</a>
                <a-textarea v-model:value="pushData.coreQuestion" maxlength="2000" :rows="3" placeholder="请输入核心问题" />
            </div>
            <div class="form-item form-colspan-3">
                <a>分析过程：</a>
                <a-textarea v-model:value="pushData.analysisProcess" maxlength="5000" :rows="4" placeholder="请输入分析过程" />
            </div>
            <div class="form-item form-colspan-2">
                <a>处理结论：</a>
                <a-textarea v-model:value="pushData.handlingResult" maxlength="2000" :rows="3" placeholder="请输入处理结论" />
            </div>
            <div class="form-item">
                <a>政策依据：</a>
                <a-textarea v-model:value="pushData.policyBasis" maxlength="2000" :rows="3" placeholder="请输入政策依据" />
            </div>
        </div>
        <template #footer>
            <a-button key="back" @click="toEditCancel">取消</a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOk">提交</a-button>
        </template>
    </a-modal>
</template>
<script>
import { updateTaxCase, getTaxCaseInfo, industryList, taxKeywordList, taxTypeList } from '@/api/service';
import { message } from 'ant-design-vue';
import { ref } from 'vue';
export default {
    name: 'editComponent',
    setup() {
        const loading = ref(false);
        const pushData = ref({
            id: null,
            caseNo: '',
            caseName: '',
            taxType: [],
            industry: [],
            taxpayerType: '',
            involvedAmount: null,
            keyword: [],
            caseSource: '',
            caseBackground: '',
            coreQuestion: '',
            analysisProcess: '',
            handlingResult: '',
            policyBasis: ''
        });
        const open = ref(false);
        const industryOptions = ref([]);
        const keywordOptions = ref([]);
        const taxTypeOptions = ref([]);

        const fetchOptions = async () => {
            const [indRes, kwRes, typeRes] = await Promise.all([
                industryList(),
                taxKeywordList(),
                taxTypeList()
            ]);
            if (indRes.code === 200) {
                industryOptions.value = indRes.data || [];
            }
            if (kwRes.code === 200) {
                keywordOptions.value = kwRes.data || [];
            }
            if (typeRes.code === 200) {
                taxTypeOptions.value = typeRes.data || [];
            }
        };
        fetchOptions();

        const openEdit = async (record) => {
            open.value = true;
            const response = await getTaxCaseInfo(record.id);
            if (response.code === 200) {
                const data = response.data;
                pushData.value = {
                    id: data.id || null,
                    caseNo: data.caseNo || '',
                    caseName: data.caseName || '',
                    taxType: data.taxType ? (typeof data.taxType === 'string' ? data.taxType.split(',') : data.taxType) : [],
                    industry: data.industry ? (typeof data.industry === 'string' ? data.industry.split(',') : data.industry) : [],
                    taxpayerType: data.taxpayerType || '',
                    involvedAmount: data.involvedAmount || null,
                    keyword: data.keyword ? (typeof data.keyword === 'string' ? data.keyword.split(',') : data.keyword) : [],
                    caseSource: data.caseSource || '',
                    caseBackground: data.caseBackground || '',
                    coreQuestion: data.coreQuestion || '',
                    analysisProcess: data.analysisProcess || '',
                    handlingResult: data.handlingResult || '',
                    policyBasis: data.policyBasis || ''
                };
            } else {
                message.error('获取案例详情失败' + response.msg);
            }
        };

        const toEditCancel = () => {
            open.value = false;
        };

        const handleOk = async () => {
            if (!pushData.value.caseName) {
                message.error('请填写案例名称');
                return;
            }
            const submitData = { ...pushData.value };
            if (Array.isArray(submitData.taxType)) {
                submitData.taxType = submitData.taxType.join(',');
            }
            if (Array.isArray(submitData.industry)) {
                submitData.industry = submitData.industry.join(',');
            }
            if (Array.isArray(submitData.keyword)) {
                submitData.keyword = submitData.keyword.join(',');
            }
            loading.value = true;
            const response = await updateTaxCase(submitData);
            if (response.code === 200) {
                message.success('修改成功');
                open.value = false;
            } else {
                message.error('修改失败' + response.msg);
            }
            loading.value = false;
        };

        return {
            loading,
            open,
            pushData,
            industryOptions,
            keywordOptions,
            taxTypeOptions,
            openEdit,
            toEditCancel,
            handleOk,
            ref
        };
    }
}
</script>
<style>
.full-modal {
    top: 5vh;
}
.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 12px 16px;
}
.form-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.form-colspan-2 {
    grid-column: span 2;
}
.form-colspan-3 {
    grid-column: 1 / -1;
}
.form-item a,
.form-colspan-2 a,
.form-colspan-3 a {
    font-size: 14px;
    font-weight: 500;
}
.startColor {
    color: #ff4757;
}
</style>
